<template>
  <div class="font mt-5" >
    <b-container fluid class=' px-0 pb-5'>
      <b-row>
        <b-col cols='8' class='mx-auto'>
              <b-row class="mb-4">
                <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
                </b-col>
                <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
                    企業コード: {{ org.code }}<br/>
                    <small>代理店連携する際に利用します</small>
                </b-col>
              </b-row>
          <b-row>
            <b-col cols='8'>

              <b-row>
                <b-col cols="4" class='px-0'>
                  <b-card class="left-card card-gray-border card-top-custom">
                    <b-card-text>
                      <b-row>
                        <b-col cols='8' class='text-left pt-1 pl-4 pr-0 notify-menu-text'>
                          承認待ち応募者
                        </b-col>
                        <b-col cols='3' class='text-left pl-0'>
                            <span class="text-red top-hit-num">{{ meta.offer_num }}件</span>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
                <b-col cols="4" class='px-0'>
                  <b-card class="no-radius border-y card-gray-border card-top-custom">
                    <b-card-text>
                      <b-row>
                        <b-col cols='8' class='text-left pt-1 pl-4 pr-0 notify-menu-text'>
                          新着メッセージ
                        </b-col>
                        <b-col cols='3' class='text-left pl-0'>
                            <span class="text-red top-hit-num">{{ meta.messages_num }}件</span>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
                <b-col cols="4" class='px-0'>
                  <b-card class="right-card card-gray-border card-top-custom">
                    <b-card-text>
                      <b-row>
                        <b-col cols='8' class='text-left pt-1 pl-4 pr-0 notify-menu-text'>
                          本日の面接予定
                        </b-col>
                        <b-col cols='3' class='text-left pl-0'>
                           <span class="text-red top-hit-num">{{ meta.interviews_num }}件</span>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols='3' class='ml-auto'>
              <b-card class="simple-card card-gray-border card-top-custom p-0">
                <b-card-text>
                  <router-link to="./favorites">
                  <p class='text-center pt-2 text-orange mb-2'> <b-icon icon="star-fill" ></b-icon>お気に入り一覧 </p>
                  </router-link>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>

          <b-row class='mt-4'>
            <b-col cols="3" class='mt-4 px-3'>
              <b-card title="求人" body-class="text-center p-0" class='no-border'>
                <b-card-text>
                  <router-link to="./jobOffer/create">
                    <b-button block class='mypage-blue-button mt-4 py-3 pl-3 text-left'><b-icon icon="plus-circle" class='mr-2 icon-button'></b-icon>求人を作成する</b-button>
                  </router-link>
                  <router-link to="./jobOffers">
                    <b-button block class='mypage-blue-button  mt-3 py-3 pl-3 text-left'><b-icon icon="files" class='mr-2 icon-button'></b-icon>求人一覧</b-button>
                  </router-link>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3" class='mt-4 px-3 left-bray-border'>
              <b-card border-variant="dark" title="応募" body-class="text-center p-0" class='no-border '>
                <b-card-text>
                  <router-link to="./applicantList">
                    <b-button block class='mypage-blue-button mt-4 py-3 pl-3 text-left'>
                      <b-icon icon="file-person" class='mr-2 icon-button'></b-icon>
                      <small><b>承認待ち応募者一覧</b></small>
                      <!-- <b-icon icon="exclamation-circle-fill" class='ml-2 batch-icon'></b-icon> -->
                    </b-button>
                  </router-link>
                  <router-link to="./matchList">
                    <b-button block class='mypage-blue-button mt-3 py-3 pl-3 text-left'><b-icon icon="calendar3" class='mr-2 icon-button'></b-icon>マッチ一覧</b-button>
                  </router-link>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3" class='mt-4 px-3 left-bray-border'>
              <b-card border-variant="dark" title="スカウト" body-class="text-center p-0" class='no-border'>
                <b-card-text>
                  <router-link to="./jobSeekerList">
                    <b-button block class='mypage-blue-button mt-4 py-4'>
                      <b-row>
                        <b-col cols='4' class='text-left pt-3 pl-4'>
                          <b-icon icon="search" class='mr-2 icon-button'></b-icon>
                        </b-col>
                        <b-col cols='7' class='text-left pt-1 pl-3'>
                          登録者を<br>検索する
                        </b-col>
                      </b-row>
                    </b-button>
                  </router-link>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3" class='mt-4 left-bray-border'>
              <b-card border-variant="dark" title="チャット/面接" body-class="text-center p-0" class='no-border'>
                <b-card-text>
                  <router-link to="./mail-box">
                    <b-button block class='mypage-blue-button mt-4 pl-3 py-3 text-left'><b-icon icon="people" class='mr-2 icon-button'></b-icon>チャットルーム</b-button>
                  </router-link>
                  <router-link to="./interviews">
                    <b-button block class='mypage-blue-button mt-3 pl-3 py-3 text-left'><b-icon icon="chat-right" class='mr-2 icon-button'></b-icon>面接予定確認</b-button>
                  </router-link>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>

          <b-row class='mt-5'>
            <b-col cols="9" class='px-1'>
              <h4 style="font-weight: 600; display: inline;  color:#4D4D4D;"><b-icon icon="person" class='mr-2 icon-button'></b-icon>審査待ち応募者</h4>
            </b-col>
            <b-col cols="3" class='px-1 text-right'>
              <router-link to="./applicantList">
                <p class="text-right font-org-blue" style="font-weight: 300; display: inline;"> ＞ 審査待ちの応募者一覧を見る</p>
              </router-link>
            </b-col>
          </b-row>

          <b-row class='mt-3'>
            <b-col cols='12' class='px-0 text-center'>
              <b-table
                responsive
                small
                :fields="seekerFields"
                :items="seekerList"
                :bordered='true'
                head-variant='light'
                class="recruit-table"
              >
                <template #cell(created_at)='data'>
                  <div class="mt-1 date-cell">
                    {{ tableDateFormat(data.item.created_at) }} <br> {{ tableTimeFormat(data.item.created_at)}}
                  </div>
                </template>
                <template #cell(job_id)='data'>
                  <router-link :to="'./jobOffer/' + data.item.job_id">
                      {{ data.item.occupation }} / {{INDUSTRY_DICTIONARY[data.item.industry]}}
                  </router-link> 
                </template>
                <template #cell(user_id)='data'>
                  <div style="width: 100%">
                    <router-link :to="'./jobSeeker/' + data.item.id">
                      <b-row>
                      <b-col cols='3' class='text-left pt-1 pl-3'>
                        <b-img :src="data.item.profile_image" rounded="circle" class="profile-image" alt=""></b-img>
                      </b-col>
                      <b-col cols='8' class='text-left'>
                        {{ data.item.last_name }} {{ data.item.sur_name }} {{ data.item.first_name }} <br>
                        <small class="small-text">{{ data.item.age }}歳/{{ GENDER_LIST[data.item.gender] }} / {{data.item.live_area}}</small>
                      </b-col>
                      </b-row>
                    </router-link> 
                  </div>
                </template>

                <template #cell(state)='data'>
                  <div class="mt-2">
                    <b-button pill @click="onSubmit(data.item, true)" class='table-confirm-button btn-text px-2 py-1 mx-1'>承認</b-button>
                    <b-button pill @click="onSubmit(data.item, false)" class='table-check-button btn-text px-2 py-1 mx-1'>非承認</b-button>
                  </div>
                </template>
                <template #cell(date)=''>
                  <div class="mt-3">
                    <p> ー </p>
                  </div>
                </template>
                <template #cell(chat)=''>
                  <div class="mt-3">
                    <p> ー </p>
                  </div>
                </template>
                <template #cell(memo)='data'>
                  <div style="width: 3rem" class="text-center mt-3 mx-auto" @click="showModal(data.item)">
                    <b-icon icon="pencil-square" font-scale="1.5" class='mr-2 icon-button'></b-icon>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

           <b-row class='mt-5'>
            <b-col cols="9" class='px-1'>
              <h4 style="font-weight: bold; display: inline;"><b-icon icon='envelope' class='mr-2 icon-button'></b-icon>新着メッセージ</h4>
            </b-col>
            <b-col cols="3" class='px-1 text-right'>
              <router-link to="./matchList">
                <p class="text-right font-org-blue" style="font-weight: 300; display: inline;"> ＞ 応募者一覧を見る</p>
              </router-link>
            </b-col>
          </b-row>

          <b-row class='mt-3'>
            <b-col cols='12' class='px-0 text-center'>
              <b-table
                responsive
                small
                :fields="newsFields"
                :items="newsMessageList"
                :bordered='true'
                head-variant='light'
                class="recruit-table"
              >
                <template #cell(date)='data'>
                  {{ tableDateFormat(data.item.created_at) }} <br> {{ tableTimeFormat(data.item.created_at)}}
                </template>
                <template #cell(title)='data'>
                    <router-link :to="'./jobOffer/' + data.item.job_id">
                      職種: [正] {{INDUSTRY_DICTIONARY[data.item.industry_id]}} / {{ data.item.occupation }}
                    </router-link> 
                </template>
                <template #cell(people)='data'>
                  <div style="width: 18rem">
                    <router-link :to="'./jobSeeker/' + data.item.id">
                      <b-row>
                      <b-col cols='3' class='text-left pt-1 pl-3'>
                        <b-img :src="data.item.profile_image" rounded="circle" class="profile-image" alt=""></b-img>
                      </b-col>
                      <b-col cols='8' class='text-left'>
                        {{ data.item.last_name }} {{ data.item.sur_name }} {{ data.item.first_name }} <br>
                        <small class="small-text">{{ data.item.age }}歳/{{ GENDER_LIST[data.item.gender] }} / {{data.item.live_area}}</small>
                      </b-col>
                      </b-row>
                    </router-link> 
                  </div>
                </template>

                <template #cell(state)='data'>
                  <p class="mb-0">{{ stateDict[data.item.fase]}} </p>
                </template>

                <template #cell(money)=''>
                  1回/1,100円
                </template>

                <template #cell(schedule)='data'>
                  <router-link :to="'./interviews/' + data.item.id">
                    <b-icon icon="calendar4-week" font-scale="1.5" class=' icon-button'></b-icon>
                  </router-link>
                </template>

                <template #cell(chat)='data'>
                  <router-link :to="'./mail-box?u_id=' + data.item.id">
                    <b-icon icon="chat" font-scale="1.5" class='icon-button'></b-icon>
                  </router-link>
                </template>

                <template #cell(memo)='data'>
                  <div style="width: 3rem" class="text-center" @click="showModal(data.item)">
                    <b-icon icon="pencil-square" font-scale="1.5" class='mr-2 icon-button'></b-icon>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row class='mt-5'>
            <b-col cols="9" class='px-1'>
              <h4 style="font-weight: bold; display: inline;"><b-icon icon='newspaper' class='mr-2 icon-button'></b-icon>最新のニュース</h4>
            </b-col>
            <b-col cols="3" class='px-1 text-right'>
              <p class="text-right font-org-blue" style="font-weight: bold; display: inline;"> ＞ 過去のニュースを見る</p>
            </b-col>
          </b-row>

          <b-row class='mt-3'>
            <b-col cols='12' class='px-0'>
              <b-list-group class='mypage-news'>
                <b-list-group-item  v-for='news in newsList' :key='news.title' class='mypage-news-row'>
                  <b-row>
                    <b-col cols='3' class='pt-1'>
                      {{news.date}}
                    </b-col>
                    <b-col cols='5' class='pt-1'>
                      <router-link to="./applicantList">
                        {{news.title}}
                      </router-link>
                    </b-col>
                  </b-row>
                </b-list-group-item>

              </b-list-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      centered
      v-model="memoModal"
      title="メモを編集"
      @ok="submitMemo"
      okTitle="保存"
      cancelTitle="キャンセル"
    >
      <p>メモを残すことができます</p>
      <b-form-textarea
        v-model="memo"
        required
        rows="5"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>


  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import axios from 'axios'

export default {
  components: {
  },
  data() {
    return {
      idToken: localStorage.idToken,
      currentRecruit: {},
      memo: "",
      memoModal: false,
      seekerList: [
      ],
      newsMessageList: [
      ],
      newsList: [
        {'date': '2021/01/1 00:00:00', 'title': '[正]建築・土木/リフォーム・内装'},
        {'date': '2021/01/1 00:00:00', 'title': '[正]建築・土木/リフォーム・内装'},
        {'date': '2021/01/1 00:00:00', 'title': '[正]建築・土木/リフォーム・内装'},
      ],
      seekerFields: [
        { key: 'created_at', label: '応募受付日時' },
        { key: 'job_id', label: '媒体/求人題名' },
        { key: 'user_id', label: '応募者情報' },
        { key: 'state', label: '対応状況' },
        { key: 'date', label: '面接日程' },
        { key: 'chat', label: 'チャット' },
        { key: 'memo', label: 'メモ' },
      ],
      stateDict: {
        'pre_interview': "面談日程調整中",
        'interview_adjustment': "面談日程回答待ち",
        'waiting_interview': "面談決定",
        'passed': "採用",
        'rejected': "不採用",
        'offer': "オファー中",
        'feedback': "フィードバック中",
      },
      newsFields: [
        { key: 'date', label: '応募受付日時' },
        { key: 'title', label: '媒体/求人題名' },
        { key: 'people', label: '応募者情報' },
        { key: 'state', label: '対応状況' },
        { key: 'money', label: '面接数/金額' },
        { key: 'schedule', label: '面接日程' },
        { key: 'chat', label: 'チャット' },
        { key: 'memo', label: 'メモ' },
      ],
      meta: {},
      org: {}
    }
  },
  methods: {
    tableDateFormat(date){
      moment.locale("ja");
      return moment(date).format('YYYY/MM/DD (ddd)');
    },
    tableTimeFormat(date){
      moment.locale("ja");
      return moment(date).format('HH:mm');
    },
    showModal(u) {
      this.currentRecruit = u
      this.memoModal = true
      this.memo = u.memo
    },
    submitMemo() {
      axios
        .patch(process.env.VUE_APP_API + "/api/org/recruit/" + this.currentRecruit.r_id, {recruit: {memo: this.memo}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {this.fetchRecruits("offer")})
    },
    onSubmit(r, result) {

      var t = ""
      var d = ""
      if(result) {
        t = "承認しますか？"
        d = "承認をすると、マッチングが成立し、選考を進めれます"
      } else {
        t = "非承認しますか？"
        d = "非承認をすると、マッチングが不成立となります"
      }

      this.$swal.fire({
        title: t,
        text: d,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '決定'
      }).then((result) => {
        if(result.isConfirmed) {
          axios
            .patch(process.env.VUE_APP_API + "/api/org/recruits/" + r.id, {is_approve: result}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(res => {
              this.fetchDashboard()
              console.log(res)
            }).catch(error => {
              console.log('this is org error', error)
            })
        }
      })


    },
    fetchDashboard() {
      axios
        .get(process.env.VUE_APP_API + "/api/org/organizations/1", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          console.log(response)
          var r = response.data.path || ""
          if(r == "./startup") {
            this.$router.replace("/organization/startup")
          } 
          this.meta = response.data.meta 
          this.seekerList = response.data.offer_lists 
          this.newsMessageList = response.data.messages
          this.org = response.data.organization
    
          this.$store.commit('setLoading', false)

        }).catch(error => {
          console.log('this is org error', error)
        })
    }
  },
  mounted(){
    this.fetchDashboard()
  },
  computed: {
    ...mapState({
        org: state => state.org.org,
        staff: state => state.staff.staff,
    })
  },
}
</script>
<style lang="scss" scoped>
.no-radius{
  border-radius: 0px !important;
}

.no-border{
  border: 0px solid #d7d7d7 !important;
}

.border-y{
  border-top: 1px solid rgba(0,0,0,.125);
  border-bottom: 1px solid rgba(0,0,0,.125);
  border-left: 0px;
  border-right: 0px;
}
.card-title{
  font-size: 1.3rem !important;
}
.new-list{
  border-bottom: 1px solid rgba(0,0,0,.125);
}
.right-card{
  border-radius: 0px 3rem 3rem 0px !important;
}

.left-card{
  border-radius: 3rem 0 0 3rem  !important;
}
.card-gray-border{
  border: 1px solid #d7d7d7;
}
.top-hit-num{
  font-size: 1.3rem;
  font-weight: 600;
}

.card-top-custom {
  .card-body{
    padding: 0.5rem;
  }
}

.mypage-blue-button{
  border: 2px solid #006FD2;
  background-color: white;
  color: #006FD2;
  font-weight: bold;
  border-radius: 10px;

  &:hover{
    color: white !important;
    background-color: #F87800 !important;
  }
}
.font-bold{
  font-weight: bold;
}
.table-blue-button{
  border: 1px solid #d7d7d7;
  background-color: white;
  color: #004ca9;

  &:active{
    color: white !important;
    background-color: #e9983e !important;
  }
}
.icon-button{
  font-size: 1.4rem !important;
}
.left-bray-border{
  border-left: 2px solid #d7d7d7 !important;
}
.batch-icon{
  color: red;
  font-size: 1.4rem !important;
}
.mypage-news{
  border-bottom: 2px solid #d7d7d7 !important;
}
.mypage-news-row{
  border-radius: 0px;
  border: 0px solid #d7d7d7 !important;
  border-top: 2px solid #d7d7d7 !important;
}
.notify-menu-text {
  font-size: 15px;
}

</style>
